<template>
  <div class="dropdown">
    <Popper
      placement="bottom-end"
      v-model:open="open"
    >
      <template #trigger>
        <div class="dropdown__trigger">
          <slot name="trigger"></slot>
        </div>
      </template>

      <div class="menu menu--dropdown menu--info typo-small-title">
        <slot></slot>
      </div>
    </Popper>
  </div>
</template>

<script setup>
import { ref } from '@vue/reactivity';
import Popper from '@/components/generic/popper.vue';

const open = ref(false);
</script>
